import { VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { Table } from '@dreryk/react-components';

import {
   useMedicalServicesColumnsConfiguration,
   useMedicalServicesDataConfiguration,
} from './MedicalServicesTable.hooks';
import { MedicalServicesTableEmptyStatePlaceholder } from './MedicalServicesTableEmptyStatePlaceholder';
import { MedicalServicesTableFooter } from './MedicalServicesTableFooter';

type MedicalServicesTableProps = {
   readonly visitSettlement: VisitSettlement | null;
};

export const MedicalServicesTable = (props: MedicalServicesTableProps): JSX.Element => {
   const columns = useMedicalServicesColumnsConfiguration();
   const dataConfiguration = useMedicalServicesDataConfiguration(props.visitSettlement?.medicalServices);

   return (
      <Table
         compact
         testId={'medicalServices'}
         dataConfiguration={dataConfiguration}
         columns={columns}
         keyExtractor={'id'}
         pageSize={Number.MAX_SAFE_INTEGER}
         bottomElement={
            props.visitSettlement ? (
               <MedicalServicesTableFooter
                  totalPrice={props.visitSettlement.totalPrice}
                  adjustmentBy={props.visitSettlement.adjustment}
               />
            ) : undefined
         }
         placeholder={<MedicalServicesTableEmptyStatePlaceholder adjustment={props.visitSettlement?.adjustment} />}
      />
   );
};
